import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BasicCards, BonusUi } from "../../../Constant";
import BasicCard from "./BasicCards";
import FlatCard from "./FlatCard";
import WithoutshadowCard from "./WithoutshadowCard";
import IconInHeading from "./IconInHeading";
import DarkColorCard from "./DarkColorCard";
import InfoColorHeader from "./InfoColorHeader";
import InfoColorBody from "./InfoColorBody";
import InfoColorFooter from "./InfoColorFooter";

const BasicCardContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={BasicCards} parent={BonusUi} title={BasicCards}  />
      <Container fluid>
        <Row>
          <BasicCard />
          <FlatCard />
          <WithoutshadowCard/>
          <IconInHeading/>
          <DarkColorCard/>
          <InfoColorHeader/>
          <InfoColorBody/>
          <InfoColorFooter/>
        </Row>
      </Container>
    </>
  );
};

export default BasicCardContainer;
